import { Box, IconButton, Tooltip } from "@material-ui/core";
import React from "react";
import EditIcon from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';
import { SpecCreator } from "./SpecCreator";
import { useDialogProps } from "legacy-components/dialog/Dialog";
import DataRemover from "modus/components/misc/DataRemover";
import DeleteIcon from "legacy-components/icons/DeleteIcon";
import { Alert } from "@material-ui/lab";
import { useAsyncAction } from "legacy-components/form/action/AsyncAction";
import ApiService from "../services/ApiService";
import {ResourceAuthorizer} from "../../authorizer/components/Authorizer";
import { makeStyles } from "@material-ui/core/styles";

interface SpecEditorProps {
  apiId: string;
  version: string;
  specId: string;
  specFile: string;
  specUrl?: string;
  refreshDeployments: ()=>void;
  serviceId: string;
}

const useStyles = makeStyles(() => ({
  specDeleteButton: {
    border: "none !important",
    borderColor: "transparent !important",
    boxShadow: "none !important",
  },
}));

export const SpecEditor: React.FC<SpecEditorProps> = React.memo(({ apiId, version, specId, specFile, specUrl, refreshDeployments, serviceId }) => {
    const classes = useStyles();
    const { open, toggle } = useDialogProps();

     const [state, { subscribe }] = useAsyncAction(() =>
     ApiService.deleteSpec(apiId, version, specId)
  );

  const handleDownloadSpec = async () => {
    const specDownloadUrl = specUrl;

    if (!specDownloadUrl || !specId) {
      return;
    }

    try {
      const response = await fetch(specDownloadUrl);
      if (!response.ok) {
        throw new Error("Failed to fetch OpenAPI spec");
      }

      const specBlob = await response.blob();
      const blobUrl = URL.createObjectURL(specBlob);
      const downloadAnchor = document.createElement("a");

      downloadAnchor.href = blobUrl;
      downloadAnchor.download = specFile || "openapi-spec.yaml";
      document.body.appendChild(downloadAnchor);
      downloadAnchor.click();
      document.body.removeChild(downloadAnchor);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      window.open(specDownloadUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>


        <ResourceAuthorizer action={"read"} resourceType={"SERVICE"} resourceId={serviceId} hideErrorMessage>
        <Tooltip title={"Download OpenAPI file."}>
          <span>
            <IconButton onClick={handleDownloadSpec} disabled={specId === undefined || specId.length === 0}>
              <GetAppIcon style={{ color: "#6a6e79" }} />
            </IconButton>
          </span>
        </Tooltip>
        </ResourceAuthorizer>
        <ResourceAuthorizer action={"update"} resourceType={"SERVICE"} resourceId={serviceId} hideErrorMessage>
        <Tooltip title={"Upload a new OpenAPI file."}>
        <IconButton onClick={toggle} >
        <EditIcon />
      </IconButton>
                </Tooltip>
        </ResourceAuthorizer>
        <ResourceAuthorizer action={"delete"} resourceType={"SERVICE"} resourceId={serviceId} hideErrorMessage>
        <DataRemover
        style={{
          border: "none"
        }}
        className={classes.specDeleteButton}
        confirmationText={""}
        enterButtonText={undefined}
        variant="outlined"
        onConfirm={subscribe}
        asyncActionState={state}
        tooltipText={"This will permanently delete the OpenApi file."}
        title="Delete openapi spec"
        successMessage="Deleted spec"
        onSuccess={refreshDeployments}
        icon={<DeleteIcon style={{ color: "#6a6e79", border: "none" }}></DeleteIcon>}
        disabled={specId === undefined || specId.length === 0}
        message={
          <Box>
            <Alert severity="error">
              Deleting a spec will break any current integrations
              using this version.
            </Alert>
            <Box marginTop={"30px"}>
              This action cannot be undone. This will permanently remove
              the open Api specification cannot be accessed elsewhere.
              <br />
            </Box>
          </Box>
        }
      />
        </ResourceAuthorizer>

        <ResourceAuthorizer action={"update"} resourceType={"SERVICE"} resourceId={serviceId} hideErrorMessage>
        <SpecCreator
          apiId={apiId}
          version={version}
          onClose={toggle}
          onOpen={open}
          refreshDeployments={refreshDeployments}
        />
        </ResourceAuthorizer>
    </>
  )
})